import { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ConsultationModal from "./ConsultationModal";

const Layout = ({ children }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="App" data-testid="app-container">
      <Navbar onScheduleClick={() => setShowModal(true)} />
      {children}
      <Footer />
      <ConsultationModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default Layout;
